export var darkColors = {pool:'#142039',tennisCourt:'#004320',home:'#7A0042',basketballCourt:'#461D00',pickleball:'#001121',other:'#142039'};